module.exports = "/_next/static/images/Opie-d118f6a8f5c473ee9e3fa58251e6bcb9.jpg";